import Config from '../launch/config'
import {
    _addToEventLog,
    _setGameOver,
    _setGameOverlayOpenState,
} from '../app/app'
import {addGameStatsToCareer, saveGame} from '../launch/store'
import {isLaunchDev} from '../launch/utils'
import party from 'party-js'
import audio from '../launch/audio'

export const gameOverCheck = (src) => {
    // console.log('gameOverCheck', src)

    const enemyPlanets = Object.keys(Config.entities).filter((key) =>
        Config.entities[key].faction?.includes(Config.enemyFactionName)
    )
    const enemyShips = Object.keys(Config.ships).filter((key) =>
        Config.ships[key].faction.includes(Config.enemyFactionName)
    )
    const friendlyPlanets = Object.keys(Config.entities).filter(
        (key) => Config.entities[key].faction === Config.userFactionName
    )
    const friendlyShips = Object.keys(Config.ships).filter(
        (key) => Config.ships[key].faction === Config.userFactionName
    )
    // const collectedArtifacts = Object.keys(Config.artifacts).filter((key) => {
    //     const artifact = Config.artifacts[key]
    //     return (
    //         artifact.isInOrbit &&
    //         artifact.orbitingEntity &&
    //         artifact.orbitingEntity.faction === Config.userFactionName
    //     )
    // })

    if (Config.isDemo) {
        return false
    }

    let isGameOver = false

    // No more colonized planets and no friendly ships
    if (!isLaunchDev && !friendlyPlanets.length && !friendlyShips.length) {
        Config.gameStats.victory = false
        isGameOver = true
    }

    // All enemy planets conquered and no enemy ships
    if (!isLaunchDev && !enemyPlanets.length && !enemyShips.length) {
        Config.gameStats.victory = true
        isGameOver = true
    }

    // All artifacts have been collected
    // if (
    //     (!isLaunchDev || isLaunchDevArtifacts) &&
    //     collectedArtifacts.length === Object.keys(Config.artifacts).length
    // ) {
    //     Config.gameStats.victory = true
    //     isGameOver = true
    // }

    if (isGameOver) {
        if (Config.gameStats.victory) {
            party.screen({
                color: ['#77cf0f', '#4c3db1', '#ffffff'],
                size: party.minmax(6, 12),
                count: 200,
                angle: -180,
                spread: 40,
                angularVelocity: party.minmax(0, 3),
            })
            setTimeout(() => {
                audio.win()
            }, 500)
        } else {
            setTimeout(() => {
                audio.lose()
            }, 500)
        }
        _setGameOver(true)
        !Config.isGameOver && _setGameOverlayOpenState(true)
        Config.isGameOver = true

        Object.keys(Config.entities).forEach((key) => {
            const entity = Config.entities[key]
            entity.discovered = true
            entity.isMiningResources = false
        })

        enemyShips.forEach((key) => {
            const ship = Config.ships[key]
            ship && ship.destroy()
        })

        Config.gameStats.artifactsCollected = Object.keys(
            Config.artifacts
        ).filter((key) => Config.artifacts[key].isCollected).length

        // Save game if it has a new game id
        if (Config.gameStats.gameId !== Config.careerStats.lastSavedGameId) {
            Config.careerStats.lastSavedGameId = Config.gameStats.gameId

            _addToEventLog({
                html: `The game has ended. ${
                    Config.gameStats.victory
                        ? `<span style="color: #${Config.colorGreen}">You Win</span>`
                        : `<span style="color: #${Config.colorRed}">You have lost</span>`
                }`,
            })

            setTimeout(() => {
                addGameStatsToCareer().then(() => saveGame('gameOverCheck'))
            }, 0)
        }
    } else {
        _setGameOver(false)
        Config.isGameOver = false
        saveGame('gameOverCheck')
    }
}

export const simulateVictory = () => {
    const difficulty = Config.difficultyLevels[Config.difficulty]

    Object.keys(Config.entities).forEach((key) => {
        const entity = Config.entities[key]

        entity.faction = Config.userFactionName
        entity.colonized = true
        entity.isColonizing = false
    })

    Object.keys(Config.ships).forEach((key) => {
        const ship = Config.ships[key]
        if (ship.faction.includes(Config.enemyFactionName)) {
            ship.destroy()
        }
    })

    Object.keys(Config.artifacts).forEach((key) => {
        const artifact = Config.artifacts[key]
        artifact.isDiscovered = true
    })

    Config.gameStats.planetsColonized += 1
    Config.gameStats.score += difficulty.planetColonizePoints

    gameOverCheck('simulateVictory')
}

export const simulateLoss = () => {
    const difficulty = Config.difficultyLevels[Config.difficulty]

    Object.keys(Config.entities).forEach((key) => {
        const entity = Config.entities[key]

        entity.faction = Config.enemyFactionName
        entity.colonized = true
        entity.discovered = true
        entity.isColonizing = false
        entity.isHomePlanet = false
    })

    Object.keys(Config.ships).forEach((key) => {
        const ship = Config.ships[key]
        if (ship && ship.faction === Config.userFactionName) {
            ship.destroy()
        }
    })

    Object.keys(Config.artifacts).forEach((key) => {
        const artifact = Config.artifacts[key]
        artifact.isDiscovered = true
    })

    Config.gameStats.planetsLost += 1
    Config.gameStats.score -= difficulty.planetColonizePoints

    gameOverCheck('simulateLoss')
}
